import { Directive} from '@angular/core';

/**
 * Generated class for the SystemMessages directive.
 *
 * See https://angular.io/docs/ts/latest/api/core/index/DirectiveMetadata-class.html
 * for more info on Angular Directives.
 */
@Directive({
  selector: '[system-messages]' // Attribute selector
})
export class SystemMessages {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/system-messages/system-messages.ts